export default "__VITE_ASSET__yI1QB$CI__"